export const ChevronRightIcon = () => (
    <svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.1395 13C0.677404 12.9986 0.262542 12.7332 0.0864185 12.3279C-0.0893392 11.9225 0.00805988 11.4559 0.332479 11.1446L5.24161 6.47048L0.332479 1.79639C-0.0563846 1.36526 -0.0307533 0.720322 0.39253 0.319148C0.814714 -0.0834186 1.49248 -0.108144 1.94615 0.262037L7.66743 5.7033C8.11086 6.12781 8.11086 6.81315 7.66743 7.23765L1.94615 12.6789C1.73305 12.883 1.44268 12.9986 1.1395 13Z"
            fill="#191919"
        />
    </svg>
);